const getTotalElements = ([{ page }]) => (page && page.totalElements) || 0;

export const paginatedSelectors = {
  getTotalElements,
};
